import { QueryParamsEnum } from '@honeycomb/data';
import { QueryParamManager } from '../utils/QueryParamManager';
import { router } from '../utils/router';
export function getRoomBoardIdParameter() {
    const queryParams = router === null || router === void 0 ? void 0 : router.query();
    const boardOptionQueryParam = queryParams === null || queryParams === void 0 ? void 0 : queryParams[QueryParamsEnum.BOARD_OPTION_ID];
    return boardOptionQueryParam;
}
export function removeBoardIdParameter() {
    var _a;
    const params = new QueryParamManager((_a = router.currentRoute()) !== null && _a !== void 0 ? _a : '/', router.currentParams());
    params.remove(QueryParamsEnum.BOARD_OPTION_ID);
    router.push(router.currentRoute(), () => [params.toString(), undefined, { shallow: true }]);
}
export function boardSelectionRouting(boardId) {
    var _a;
    const paramManager = new QueryParamManager((_a = router.currentRoute()) !== null && _a !== void 0 ? _a : '/', router.currentParams());
    paramManager.add(QueryParamsEnum.BOARD_OPTION_ID, boardId);
    router.replace(router.currentRoute(), () => [paramManager.toString(), undefined, { shallow: true }]);
}
